var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5625 7.53125H2.75C2.43934 7.53125 2.1875 7.78309 2.1875 8.09375V10.9062C2.1875 11.2169 2.43934 11.4688 2.75 11.4688H5.5625C5.87316 11.4688 6.125 11.2169 6.125 10.9062V8.09375C6.125 7.78309 5.87316 7.53125 5.5625 7.53125Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 3.3125H12.3125C12.0018 3.3125 11.75 3.56434 11.75 3.875V7.25C11.75 7.56066 12.0018 7.8125 12.3125 7.8125H15.6875C15.9982 7.8125 16.25 7.56066 16.25 7.25V3.875C16.25 3.56434 15.9982 3.3125 15.6875 3.3125Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 11.1875H12.3125C12.0018 11.1875 11.75 11.4393 11.75 11.75V15.125C11.75 15.4357 12.0018 15.6875 12.3125 15.6875H15.6875C15.9982 15.6875 16.25 15.4357 16.25 15.125V11.75C16.25 11.4393 15.9982 11.1875 15.6875 11.1875Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.5H8.9375",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.4375H10.625C10.4031 13.4384 10.1833 13.3954 9.97814 13.311C9.77298 13.2265 9.58658 13.1022 9.4297 12.9453C9.27281 12.7884 9.14855 12.602 9.06407 12.3969C8.9796 12.1917 8.93658 11.9719 8.93751 11.75V7.25001C8.93658 7.02815 8.9796 6.80829 9.06407 6.60314C9.14855 6.39798 9.27281 6.21158 9.4297 6.0547C9.58658 5.89781 9.77298 5.77355 9.97814 5.68907C10.1833 5.6046 10.4031 5.56158 10.625 5.56251H11.75",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/Flow.95cbf8c249eaa320231cc986d637e93a.svg";
export { ForwardRef as ReactComponent };